import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { apiPost, operationsClient } from '@/lib/api';
import { estimateKeys } from '@/lib/queryKeys';

export interface CollectDepositInput {
  id: string;
  method: 'cash' | 'check' | 'other';
  notes?: string;
}

export function useCollectDeposit() {
  const queryClient = useQueryClient();
  return useApiMutation<unknown, CollectDepositInput>({
    mutationFn: ({ id, method, notes }) =>
      apiPost(operationsClient, `/estimates/${id}/collect-deposit`, { method, notes }),
    onSuccess: (_data, { id }) => {
      void queryClient.invalidateQueries({ queryKey: estimateKeys.detail(id) });
      void queryClient.invalidateQueries({ queryKey: estimateKeys.lists() });
      toast.success('Deposit collected');
    },
  });
}
